import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "lib-flexible-computer"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import * as echarts from 'echarts';//引入echarts
import 'video.js/dist/video-js.css';
import './assets/fonts/font.css'
Vue.prototype.$echarts=echarts

import Axios from 'axios';
Vue.prototype.$axios = Axios

import VueAwesomeSwiper from 'vue-awesome-swiper' 
import 'swiper/dist/css/swiper.css' 
Vue.use(VueAwesomeSwiper) 

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
